"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertFloatingCopperResultToReview = convertFloatingCopperResultToReview;
const common_1 = require("./common");
function convertFloatingCopperResultToReview(nodes) {
    return (problem) => {
        const designatorUidMap = {};
        const name = Array.from(new Set(problem.affectedItems.map((a) => {
            const designator = (0, common_1.sanitizeDesignator)(a.itemLabel ?? (0, common_1.getLabelForPcbNode)(nodes[a.uid]));
            designatorUidMap[designator] = a.uid;
            return designator;
        }))).join(", ");
        return { name, designatorUidMap };
    };
}
//# sourceMappingURL=floatingCopper.js.map